import { Box, Grid, MenuItem, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import {
  setEvaluationResults,
  setNotesToCustomer,
  setRepairType,
  setServiceType,
} from '../../../stores/confirmedInspection/slice';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { MaxLength } from '../../../_constants/maxLengthConst';

type ResultInformationProps = {
  repairType: number | null;
  repairTypeList: { id: number; name: string }[];
  serviceType: string;
  serviceTypeList: { id: string; name: string }[];
  evaluationResults: string;
  notesToCustomer: string;
};

const ResultInformation: React.FC<ResultInformationProps> = ({
  repairType,
  repairTypeList,
  serviceType,
  serviceTypeList,
  evaluationResults,
  notesToCustomer,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleSetRepairType = (value: string | undefined) => {
    if (value !== undefined) {
      dispatch(setRepairType(Number(value)));
    } else {
      // ドロップダウン先頭（空欄）を選択した場合を想定：明示的にnullを設定する(value(0)を設定すると連携に失敗してしまうため)
      dispatch(setRepairType(null));
    }
  };
  const [lengthEvaluationResult, setLengthEvaluationResult] = useState(
    evaluationResults.length,
  );
  const [lengthNotesToCustomer, setLengthNotesToCustomer] = useState(
    notesToCustomer.length,
  );

  const handleSetServiceType = (value: string | undefined) => {
    if (value !== undefined) {
      dispatch(setServiceType(value));
    }
  };

  // 初期化後にlengthが更新されるので対応する
  useEffect(() => {
    setLengthEvaluationResult(evaluationResults.length);
  }, [evaluationResults.length]);
  useEffect(() => {
    setLengthNotesToCustomer(notesToCustomer.length);
  }, [notesToCustomer.length]);

  return (
    <Grid
      container
      size={12}
      spacing={1}
      sx={{ bgcolor: '#F2F2F2', margin: '20px', borderRadius: '4px' }}
    >
      {/* 1行目 */}
      <Grid size={4} style={{ padding: '20px 10px 10px 20px' }}>
        <TextField
          id="repair_type"
          select
          label={t('LBL_REPAIR_TYPE')}
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{ bgcolor: 'warning.light', borderRadius: '6px' }}
          fullWidth
          size="small"
          value={repairType ?? ''}
        >
          {repairTypeList.map((item, i) => (
            <MenuItem
              key={`repair_type_${i}`}
              value={item.id}
              onClick={(event) =>
                handleSetRepairType(event.currentTarget.dataset.value)
              }
            >
              {item.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={4} style={{ padding: '20px 10px 10px 10px' }}>
        <TextField
          id="service_type"
          select
          label={t('LBL_SERVICE_TYPE')}
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{ bgcolor: 'warning.light', borderRadius: '6px' }}
          fullWidth
          size="small"
          value={serviceType}
        >
          {serviceTypeList.map((item, i) => (
            <MenuItem
              key={`service_type_${i}`}
              value={item.id}
              onClick={(event) =>
                handleSetServiceType(event.currentTarget.dataset.value)
              }
            >
              {item.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {/* 2行目 */}
      <Grid size={12} style={{ padding: '10px 20px' }}>
        <Box sx={{ position: 'relative' }}>
          <TextField
            key={'evaluation_result'}
            id="evaluation_result"
            label={t('LBL_EVALUATION_RESULT')}
            multiline
            fullWidth
            size="small"
            minRows={3}
            defaultValue={evaluationResults}
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: {
                maxLength: MaxLength.ConfirmedInspection.EVALUATION_RESULT,
                style: { paddingBottom: '24px' },
              },
            }}
            sx={{
              bgcolor: 'background.paper',
              borderRadius: '6px',
            }}
            onChange={(event) =>
              setLengthEvaluationResult(event.target.value.length)
            }
            onBlur={(event) =>
              dispatch(setEvaluationResults(event.target.value))
            }
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              right: 16,
              fontSize: '0.75rem',
            }}
          >
            {lengthEvaluationResult} /{' '}
            {MaxLength.ConfirmedInspection.EVALUATION_RESULT}
          </Box>
        </Box>
      </Grid>
      {/* 3行目 */}
      <Grid size={12} style={{ padding: '10px 20px 20px' }}>
        <Box sx={{ position: 'relative' }}>
          <TextField
            key={'notes_to_customer'}
            id="notes_to_customer"
            label={t('LBL_NOTES_TO_CUSTOMER')}
            multiline
            fullWidth
            size="small"
            minRows={3}
            defaultValue={notesToCustomer}
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: {
                maxLength: MaxLength.ConfirmedInspection.NOTES_TO_CUSTOMER,
                style: { paddingBottom: '24px' },
              },
            }}
            sx={{
              bgcolor: 'background.paper',
              borderRadius: '6px',
            }}
            onChange={(event) =>
              setLengthNotesToCustomer(event.target.value.length)
            }
            onBlur={(event) => dispatch(setNotesToCustomer(event.target.value))}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              right: 16,
              fontSize: '0.75rem',
            }}
          >
            {lengthNotesToCustomer} /{' '}
            {MaxLength.ConfirmedInspection.NOTES_TO_CUSTOMER}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ResultInformation;
